<template>
  <b-container fluid>
    <b-row class="pb-3">
      <b-col
        class="my-auto"
        cols="auto"
      >
        ค้นหาผู้ใช้
      </b-col>
      <b-col
        class="my-auto"
        cols="auto"
      >
        <b-form-input
          v-model="filters.username"
          @input="searchFilter"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          :items="items.data"
          :fields="fields"
          striped
          bordered
          responsive
        />
        <b-pagination
          v-model="filters.page"
          size="md"
          :total-rows="items.total"
          :per-page="items.per_page"
          @input="getDataPerPage"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: "UserHistory",
        data() {
            return {
                fields: [
                    {
                        label: 'User',
                        key: 'user.name'
                    },
                    {
                      label: 'Module',
                        key: 'module'
                    },
                    {
                      label: 'Action',
                        key: 'action'
                    },
                    {
                      label: 'Date Time',
                        key: 'created_at'
                    }
                ],
                items: [],
                filters: {
                    username: '',
                    page: 1
                },
                debounce: false,
            }
        },
        mounted() {
            this.getDataPerPage()
        },
        methods: {
            ...mapActions({
                'fetchData': 'Settings/fetchUserHistory'
            }),
            getDataPerPage() {
                this.fetchData(this.filters).then(res => {
                    this.items = res
                }).catch(err => {
                    this.$swal.fire(
                        'เกิดข้อผิดพลาด',
                        `${err.message}`,
                        'error'
                    )
                })
            },
            searchFilter() {
                if (!this.debounce) {
                    this.debounce = true
                    setTimeout( () => {
                        this.fetchData(this.filters).then(res => {
                            this.items = res
                            this.debounce = false
                        }).catch(err => {
                            this.$swal.fire(
                                'เกิดข้อผิดพลาด',
                                `${err.message}`,
                                'error'
                            )
                        })
                    }, 500)
                }


            }
        },

    }
</script>

<style scoped>

</style>
